import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "opt" }

import { IEchartHeaderOption } from "./interface.ts";

export default /*#__PURE__*/_defineComponent({
  props: {
  list: {
    type: Object as () => IEchartHeaderOption,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "",
        key: index
      }, [
        _createElementVNode("span", {
          style: _normalizeStyle({ background: item.color })
        }, null, 4),
        _createTextVNode(" " + _toDisplayString(item.label), 1)
      ]))
    }), 128))
  ]))
}
}

})